module.exports = __webpack_public_path__ + "static/media/up-arrow.733c95b3.svg";